import React, {FC, PropsWithChildren} from 'react';
import styled from 'styled-components';

/*
 * Style.
 */

const StyledActionsDiv = styled.div`
  grid-area: right-actions;
  position: relative;
`;

const StyledOverlayDiv = styled.div`
  position: absolute;
  top: 6px;
  right: 14px;

  display: grid;
  grid-gap: 4px;
  grid-auto-flow: column;
  grid-auto-columns: max-content;
`;

/*
 * Component.
 */

export const ComposerSectionRightActions: FC<PropsWithChildren<unknown>> = (props) => (
  <StyledActionsDiv>
    <StyledOverlayDiv>{props.children}</StyledOverlayDiv>
  </StyledActionsDiv>
);
